<template>
    <form class="section-hom-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group" :class="{'has-error': errors['title']}">
            <label for="title" class="col-sm-2 control-label">Titulo </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.section.title"  required >
                <div class="help-block" v-for="e in errors['title']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group" :class="{'has-error': errors['subtitle']}">
            <label for="title" class="col-sm-2 control-label">Sub Titulo </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="subtitle" v-model="data.section.subtitle"   >
                <div class="help-block" v-for="e in errors['subtitle']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group" :class="{'has-error': errors['url']}">
            <label for="title" class="col-sm-2 control-label">URL</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="url" v-model="data.section.url"   >
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group"  :class="{'has-error': errors['active']}">
            <label for="" class="col-sm-2 control-label">Activo</label>
            <div class="col-sm-10">
                <el-switch
                    v-model="data.section.status"
                    on-text="SI"
                    off-text="NO"                    
                >
                </el-switch>
            </div>
            <br><br> 
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-admin-page-contents/home">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select{
        display: block;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import ElSwitch from 'element-ui/lib/switch';
import Multiselect from "vue-multiselect";
import locale from 'element-ui/lib/locale/lang/es';
import Vue from 'vue';
import { Message } from 'element-ui';
Vue.use(ElementUI, { locale });


export default {
    
    data: function(){
        const seccionurl = _.cloneDeep(this.seccionurl);
       

        var data = {
            section:seccionurl,
        };

        return {
            data : data, 
            row: seccionurl.row,
            days:seccionurl.days,
            errors: {}
        }
    },
    props: ["seccionurl", "edit"],  
    components:{
        ElSwitch,
        Multiselect, 
        ElSelect,
        ElOption
    },
    
    methods:{
        validateForm:function(){
            this.errors = {};

            var title = this.data.title === '' || this.data.title === null;
            var title_length = this.data.title.length> 255;
            var sub_title_length = this.data.subtitle.length> 255;
            var errores = {};

            var url_length = this.data.url.length> 255;

            if(title){ errores["title"] = ["El campo titulo  no puede estar vacío."]; }
            if(title_length){ errores["title"] = ["El campo titulo no puede exceder los 255 caracteres."]; }
            if(sub_title_length){ errores["subtitle"] = ["El campo subtitulo no puede exceder los 255 caracteres."]; }
            if(url_length){ errores["url"] = ["El campo url no puede exceder los 255 caracteres."]; }
            if(title || title_length || sub_title_length || description_lenth){
                this.errors = errores;
                return true; 
            }else{
                return false;
            }
        },
        submit:function(){
            if(!this.validateForm){
                this.$message.error('Revise los errores en el formulario antes de continuar.');    
            }else{

                axios({
                     url: this.edit
                        ? "backend/sections-admin-page-contents/update/contentsurl/" + this.data.section.id
                        : "backend/ssections-admin-page-contents/store/contentsurl",
                        method: this.edit ? "PUT" : "POST",
                    data: this.data
                })
                .then(response => {
                    //console.log('respuesta' , response)
                    window.location.replace(response.data.redirect);
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            }
        },
    }
}
</script>